import { Flex, Text, toaster } from 'components'
import { useCurrentUser } from 'components/providers'
import { isEqual } from 'lodash-es'
import { useEffect } from 'react'
import { generatePath, useNavigate, useParams } from 'react-router'
import { ITrait } from 'types'
import {
  deleteDoc,
  removeEmpty,
  setDoc,
  useBreakpoint,
  useDisclosure,
  usePrefCurrentWorkspace,
} from 'utils'
import ManageTraitDrawer from '../components/traitContent/ManageTraitDrawer'
import TraitContentList from '../components/traitContent/TraitContentList'
import { RoutePath } from '../utils/routing'
import { useTraits } from '../utils/traitUtils'

export default function TraitContentPage() {
  const user = useCurrentUser()
  const [workspaceId] = usePrefCurrentWorkspace()
  const navigate = useNavigate()
  const { id } = useParams()
  const { onClose, onOpen, open } = useDisclosure()
  const isMobile = useBreakpoint() < 1

  const { traits, status } = useTraits()
  const trait = traits.find(trait => trait.id === id)
  const toList = () => navigate(generatePath(RoutePath.Trait, { workspaceId: workspaceId! }))

  useEffect(() => {
    if (id) onOpen()
    else onClose()
  }, [id])

  async function handleOnClose(body?: ITrait) {
    if (body && !isEqual(body, trait)) {
      try {
        await setDoc(user!.id, 'traits2', removeEmpty(body))
      } catch (error) {
        console.error(error)
        toaster.create({ type: 'error', description: 'Failed to update trait' })
      }
    }

    toList()
  }

  async function handleDelete() {
    if (!trait) return
    await deleteDoc('traits2', trait.id)

    toList()
  }

  return (
    <Flex
      direction="column"
      gap={4}
      flex="auto"
      p={isMobile ? 4 : 0}
      overflowY="auto"
      overflowX="hidden"
    >
      <Text textStyle="h3" pt={2}>
        Trait Content
      </Text>

      <TraitContentList status={status} traits={traits} />

      <ManageTraitDrawer open={open} trait={trait} onDelete={handleDelete} onDone={handleOnClose} />
    </Flex>
  )
}
